import axios from '@axios'

const route = 'sales/self_service_screen'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * Carrega a configuração do totem (categorias e produtos por tela)
     */
    getScreen() {
      return axios.get(route)
    },

    /**
     * Carrega as categorias e produtos de uma lista de categorias
     */
    getProductsByCategories(context, categoryIds) {
      return axios.post(`${route}/products`, { category_ids: categoryIds })
    },

    /**
     * Cria uma comanda (ordem de serviço) a partir dos itens do autoatendimento
     */
    createOrderService(context, items) {
      return axios.post(`${route}/order_service`, { items })
    },
  },
}
